import { backboneModelProperties } from "./../../decorators/backbone-properties";
import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { FiltersCollection } from "./../collections/filters";
import {prop} from "../../decorators/property";

@backboneModelProperties({
    relations: [
        {
            type: Backbone.Many,
            key: "Filters",
            collectionType: FiltersCollection
        }
    ],
    defaults: {
        Filters: []
    }
})
export class AdvancedSearchFilterGroupModel extends AuthorizationModel {

    @prop() public Identifier: string;
    @prop() public Label: string;
    @prop() public Filters: FiltersCollection;

    constructor(options?: any) {
        super(options);
    }

    public get IncludedFiltersCount(): number {
        if (!this.Filters) {
            return 0;
        }
        let count = 0 ;
        this.Filters.each((f) => {
            if (f.Included) {
                count ++;
            }
        });

        return count;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/advanced-search-filter-group.ts